// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/@rsbuild+core@1.7.3/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font-slim-l-activity-c3eZqG {
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
}

.email-verify-B140Al {
  flex-direction: column;
  align-items: center;
  display: flex;
}

.email-verify-B140Al .title-nStHbb {
  color: #000;
  text-align: center;
  width: 100%;
  margin-bottom: 32px;
  padding: 10px;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.email-verify-B140Al .description-lvgkik {
  color: var(--js-gray-7);
  text-align: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  margin-bottom: 40px;
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
  display: flex;
}

.email-verify-B140Al .code-QV1LS0 .arco-input {
  background-color: #fff;
  border: none;
  border-radius: 12px;
  width: 48px;
  height: 48px;
  font-size: 20px;
  font-weight: 600;
}

.email-verify-B140Al .code-QV1LS0 .arco-input:hover {
  box-shadow: 0 0 0 1px #0000000f, 0 1px 6px #0000000a;
}

.email-verify-B140Al .code-QV1LS0 .arco-input:focus {
  box-shadow: 0 0 0 1px #000, 0 0 0 2px #fff, 0 0 0 3px #0000000f, 0 1px 12px #0000000f;
}

.email-verify-B140Al .code-error-ZnSPvT .arco-input {
  box-shadow: 0 0 0 1px #ef44441a;
}

.email-verify-B140Al .code-error-ZnSPvT .arco-input:hover {
  background-color: #fff;
  box-shadow: 0 0 0 1px #ef444480, 0 1px 12px #0000000f;
}

.email-verify-B140Al .code-error-ZnSPvT .arco-input:focus {
  box-shadow: 0 0 0 1px var(--js-color-red), 0 0 0 2px #fff, 0 0 0 3px #0000000f, 0 1px 12px #0000000f;
}

.email-verify-B140Al .error-message-Z7_QA_ {
  width: 100%;
  height: 24px;
  color: var(--js-color-red);
  text-align: left;
  margin-top: 4px;
  padding: 0 10px;
  font-size: 13px;
  line-height: 24px;
}

.email-verify-B140Al .resend-yB28hz {
  border-radius: 6px;
  height: 32px;
  margin-top: 10px;
  margin-bottom: 50px;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
}

.email-verify-B140Al .resend-yB28hz.wg-button-loading {
  color: #000;
}

.email-verify-B140Al .resend-yB28hz.wg-button-loading .wg-loading__icon {
  color: #000 !important;
}

.email-verify-B140Al .verify-button-M1GFfT {
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}

.email-verify-B140Al .spam-tips-WIc8wf {
  color: var(--js-gray-7);
  text-align: center;
  margin-top: 16px;
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
}
`, "",{"version":3,"sources":["webpack://./root/packages/login/src/components/EmailVerify/index.module.less","webpack://./src/components/EmailVerify/index.module.less"],"names":[],"mappings":"AAAA;ECCE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qFAAqF;AACvF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* font start */\n.font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n/* font end */\n.email-verify {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.email-verify .title {\n  width: 100%;\n  padding: 10px;\n  color: black;\n  margin-bottom: 32px;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n  text-align: center;\n}\n.email-verify .description {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 40px;\n  color: var(--js-gray-7);\n  text-align: center;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 22px;\n}\n.email-verify .code :global(.arco-input) {\n  width: 48px;\n  height: 48px;\n  font-size: 20px;\n  font-weight: 600;\n  background-color: white;\n  border: none;\n  border-radius: 12px;\n}\n.email-verify .code :global(.arco-input):hover {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 1px 6px rgba(0, 0, 0, 0.04);\n}\n.email-verify .code :global(.arco-input):focus {\n  box-shadow: 0 0 0 1px #000000, 0 0 0 2px #ffffff, 0 0 0 3px rgba(0, 0, 0, 0.06), 0 1px 12px rgba(0, 0, 0, 0.06);\n}\n.email-verify .code-error :global(.arco-input) {\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.1);\n}\n.email-verify .code-error :global(.arco-input):hover {\n  background-color: white;\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.5), 0 1px 12px rgba(0, 0, 0, 0.06);\n}\n.email-verify .code-error :global(.arco-input):focus {\n  box-shadow: 0 0 0 1px var(--js-color-red), 0 0 0 2px #ffffff, 0 0 0 3px rgba(0, 0, 0, 0.06), 0 1px 12px rgba(0, 0, 0, 0.06);\n}\n.email-verify .error-message {\n  width: 100%;\n  height: 24px;\n  padding: 0 10px;\n  margin-top: 4px;\n  font-size: 13px;\n  line-height: 24px;\n  color: var(--js-color-red);\n  text-align: left;\n}\n.email-verify .resend {\n  height: 32px;\n  padding: 8px 10px;\n  margin-top: 10px;\n  margin-bottom: 50px;\n  line-height: 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n}\n.email-verify .resend:global(.wg-button-loading) {\n  color: black;\n}\n.email-verify .resend:global(.wg-button-loading) :global(.wg-loading__icon) {\n  color: black !important;\n}\n.email-verify .verify-button {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.email-verify .spam-tips {\n  margin-top: 16px;\n  color: var(--js-gray-7);\n  text-align: center;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 22px;\n}\n",".font-slim-l-activity {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.email-verify {\n  flex-direction: column;\n  align-items: center;\n  display: flex;\n}\n\n.email-verify .title {\n  color: #000;\n  text-align: center;\n  width: 100%;\n  margin-bottom: 32px;\n  padding: 10px;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 28px;\n}\n\n.email-verify .description {\n  color: var(--js-gray-7);\n  text-align: center;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  margin-bottom: 40px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 22px;\n  display: flex;\n}\n\n.email-verify .code :global(.arco-input) {\n  background-color: #fff;\n  border: none;\n  border-radius: 12px;\n  width: 48px;\n  height: 48px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.email-verify .code :global(.arco-input):hover {\n  box-shadow: 0 0 0 1px #0000000f, 0 1px 6px #0000000a;\n}\n\n.email-verify .code :global(.arco-input):focus {\n  box-shadow: 0 0 0 1px #000, 0 0 0 2px #fff, 0 0 0 3px #0000000f, 0 1px 12px #0000000f;\n}\n\n.email-verify .code-error :global(.arco-input) {\n  box-shadow: 0 0 0 1px #ef44441a;\n}\n\n.email-verify .code-error :global(.arco-input):hover {\n  background-color: #fff;\n  box-shadow: 0 0 0 1px #ef444480, 0 1px 12px #0000000f;\n}\n\n.email-verify .code-error :global(.arco-input):focus {\n  box-shadow: 0 0 0 1px var(--js-color-red), 0 0 0 2px #fff, 0 0 0 3px #0000000f, 0 1px 12px #0000000f;\n}\n\n.email-verify .error-message {\n  width: 100%;\n  height: 24px;\n  color: var(--js-color-red);\n  text-align: left;\n  margin-top: 4px;\n  padding: 0 10px;\n  font-size: 13px;\n  line-height: 24px;\n}\n\n.email-verify .resend {\n  border-radius: 6px;\n  height: 32px;\n  margin-top: 10px;\n  margin-bottom: 50px;\n  padding: 8px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.email-verify .resend:global(.wg-button-loading) {\n  color: #000;\n}\n\n.email-verify .resend:global(.wg-button-loading) :global(.wg-loading__icon) {\n  color: #000 !important;\n}\n\n.email-verify .verify-button {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.email-verify .spam-tips {\n  color: var(--js-gray-7);\n  text-align: center;\n  margin-top: 16px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"font-slim-l-activity": `font-slim-l-activity-c3eZqG`,
	"fontSlimLActivity": `font-slim-l-activity-c3eZqG`,
	"email-verify": `email-verify-B140Al`,
	"emailVerify": `email-verify-B140Al`,
	"title": `title-nStHbb`,
	"description": `description-lvgkik`,
	"code": `code-QV1LS0`,
	"code-error": `code-error-ZnSPvT`,
	"codeError": `code-error-ZnSPvT`,
	"error-message": `error-message-Z7_QA_`,
	"errorMessage": `error-message-Z7_QA_`,
	"resend": `resend-yB28hz`,
	"verify-button": `verify-button-M1GFfT`,
	"verifyButton": `verify-button-M1GFfT`,
	"spam-tips": `spam-tips-WIc8wf`,
	"spamTips": `spam-tips-WIc8wf`
};
export default ___CSS_LOADER_EXPORT___;
